<template>
    <div v-if="dataWhole" class="question-item">
        <question-show
            :data="data.Content"
            class="font-size18 font-medium"
            :start="`<span>${qIndex + 1}、</span>`"
        >
        </question-show>
        <div
            v-if="
                data.SubjectType === 1 ||
                data.SubjectType === 2 ||
                data.SubjectType === 4
            "
        >
            <div
                class="xy-center jf-start row"
                v-for="(type, index) in data.AnswerList"
                :key="index"
            >
                <div
                    v-if="data.SubjectType === 1 || data.SubjectType === 4"
                    class="radio xy-center"
                    :class="{
                        'b-c-256 c-fff border-none':
                            String.fromCharCode(64 + type.RankNum) ===
                            data.Answer,
                    }"
                >
                    {{ String.fromCharCode(64 + type.RankNum) }}
                </div>
                <div
                    v-if="data.SubjectType === 2"
                    class="checkbox xy-center"
                    :class="{
                        'b-c-256 c-fff border-none': data.Answer.includes(
                            String.fromCharCode(64 + type.RankNum)
                        ),
                    }"
                >
                    {{ String.fromCharCode(64 + type.RankNum) }}
                </div>
                <question-show
                    :data="type.Content"
                    class="font-size14"
                ></question-show>
            </div>
            <div class="xy-center jf-start row font-size14">
                <span class="no-wrap">答案：</span>
                <span>{{ data.Answer | answer }}</span>
            </div>
        </div>
        <div v-if="data.SubjectType === 3">
            <question-show
                v-for="(answer, index) in data.AnswerList"
                :key="index"
                :data="answer.Content"
                class="row font-size14"
            >
                <span slot="start" class="no-wrap">答案{{ index + 1 }}：</span>`
            </question-show>
        </div>
        <div v-if="data.SubjectType === 5" class="xy-start row">
            <span class="font-size14 no-wrap">答案：</span>
            <question-show :data="data.AnswerList[0].Content" class="font-size14">
            </question-show>
        </div>
        <div class="xy-start row">
            <span class="font-size14 no-wrap">解析：</span
            ><question-show
                :data="data.Analysis"
                class="font-size14"
            ></question-show>
        </div>
        <div class="xy-center jf-start row">
            <span class="font-size14">难度：</span
            ><span>{{
                data.Hardlevel === 1
                    ? "简单"
                    : data.Hardlevel === 2
                    ? "普通"
                    : "困难"
            }}</span>
        </div>
    </div>
    <div v-else class="no-whole">
        试题数据不完整
    </div>
</template>

<script>
import QuestionShow from "./QuestionShow.vue";
import questionHelp from "@/mixins/questionHelp";
export default {
    components: { QuestionShow },
    mixins: [questionHelp],
    props: {
        data: {
            type: Object,
        },
        qIndex: {
            type: Number,
        },
    },
    mounted() {
        if (Array.isArray(this.data.Answer)) {
            this.data.Answer = this.data.Answer.sort().join("、");
        }
    },
    computed: {
        dataWhole() {
            return this.checkQuesData(this.data)
        }
    },
    filters: {
        answer(val) {
            if (Array.isArray(val)) {
                return [...val].sort().join("、");
            } else {
                return val
            }
        }
    },
    watch: {
        data() {
            // this.data.RankNum = this.qIndex + 1;
        },
    },
    methods: {},
};
</script>

<style lang="less" scoped>
.question-item {
    .row {
        margin-top: 20px;
    }
    .radio,
    .checkbox {
        width: 30px;
        height: 30px;
        border: 1px solid #e5e8ec;
        margin-right: 10px;
    }
    .radio {
        border-radius: 15px;
    }
    .checkbox {
        border-radius: 4px;
    }
    ::v-deep p {
        display: inline;
    }
}
.no-whole {
    background: red;
    height: 100px;
    color: white;
    font-size: 18px;
    width: 100%;
}
</style>
